import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'

const RelatedRegisterable = {
  flags: (subscription, user) => {
    const results = []
    if (subscription.lineItem) {
      if (subscription.lineItem.isTemp) {
        results.push("is_temp")
      }
      if (subscription.lineItem.isOfficeHour) {
        results.push("is_office_hour")
      }
      if (!isWithinYearsFromNow(subscription.lineItem.processed_at, 2)) {
        results.push("processed_at_not_within_range")
      }
    }
    if (!subscription.enrollment) {
      results.push('no_enrollment')
    } else {
      if (!isWithinYearsFromNow(subscription.enrollment.end_at || subscription.enrollment.section_end_at, 2)) {
        results.push('end_at_not_within_range')
      }
      // shopper#149 : only allow if user is assignee of the enrollment
      if (!user.is(subscription.enrollment.assigned_to)) {
        results.push('user_not_assigned_to')
      }
      // hide if does not have registration related products
      if (!subscription.enrollment.has_registration_related_products) {
        results.push('no_registration_related_products')
      }
      if (["expired", "section_ended", "disabled", "section_not_started"].indexOf(subscription.enrollment.status) != -1) {
        results.push(`invalid_status_${subscription.enrollment.status}`)
      }
      if (subscription.enrollment.isTemp) {
        results.push("is_temp_enroll")
      }
      // shopper#205 : hide if deactivated
      if (subscription.enrollment.isDeactivated) {
        results.push('deactivated')
      }
      if (subscription.enrollment.isRetaken) {
        results.push('enrollment_retaken')
      }
    }

    return results
  }
}

export default RelatedRegisterable
